var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 14.112L15.0477 12.3933C14.8397 12.3001 14.6114 12.2614 14.3843 12.281C14.1573 12.3005 13.939 12.3776 13.75 12.505L11.593 13.9402C10.2783 13.3017 9.21395 12.2433 8.56797 10.9324L9.99453 8.74955C10.1211 8.56038 10.1983 8.3426 10.2194 8.11599C10.2404 7.88937 10.2044 7.6611 10.1148 7.45189L8.3875 3.42142C8.26697 3.14927 8.06287 2.92259 7.80482 2.77425C7.54677 2.62591 7.24818 2.56362 6.95234 2.59642C5.79184 2.74845 4.72602 3.31673 3.95306 4.1956C3.18009 5.07447 2.75258 6.20413 2.75 7.37455C2.75 14.198 8.30156 19.7495 15.125 19.7495C16.2954 19.747 17.4251 19.3195 18.3039 18.5465C19.1828 17.7735 19.7511 16.7077 19.9031 15.5472C19.9359 15.2514 19.8736 14.9528 19.7253 14.6947C19.577 14.4367 19.3503 14.2326 19.0781 14.112Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.f48276b382d64425c55aef9eb1762b95.svg";
export { ForwardRef as ReactComponent };